import { render, staticRenderFns } from "./mdBackList.vue?vue&type=template&id=18ed5b60&scoped=true"
import script from "./mdBackList.vue?vue&type=script&lang=js"
export * from "./mdBackList.vue?vue&type=script&lang=js"
import style0 from "./mdBackList.vue?vue&type=style&index=0&id=18ed5b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ed5b60",
  null
  
)

export default component.exports